export const PriceOverride = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="6" width="26" height="14" rx="1" stroke="currentColor" stroke-width="2"/>
<circle cx="16" cy="13" r="3" stroke="currentColor" stroke-width="2"/>
<circle cx="24" cy="13" r="1" stroke="currentColor" stroke-width="2"/>
<circle cx="8" cy="13" r="1" stroke="currentColor" stroke-width="2"/>
<path d="M30 24H2" stroke="currentColor" stroke-width="2"/>
<path d="M30 28H2" stroke="currentColor" stroke-width="2"/>
</svg>`;
